/* <pa-bfcm-countdown data-target="2026-11-13T00:00:00-07:00"> — ticks once a second, clamps at zero. */
if (!customElements.get('pa-bfcm-countdown')) {
  class PaBfcmCountdown extends HTMLElement {
    connectedCallback() {
      this.target = Date.parse(this.dataset.target);
      if (Number.isNaN(this.target)) return;

      this.nodes = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
      const values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor((remaining % 86400) / 3600),
        minutes: Math.floor((remaining % 3600) / 60),
        seconds: remaining % 60,
      };

      for (const unit in values) {
        this.nodes[unit].textContent = String(values[unit]).padStart(2, '0');
      }

      if (remaining === 0) clearInterval(this.timer);
    }
  }

  customElements.define('pa-bfcm-countdown', PaBfcmCountdown);
}
